import { useClusters } from '@cast/shared-cluster-context-data-access';
import {
  TRIAL_ENABLED,
  useTrialStatusQuery,
} from '@cast/shared-trial-data-access';
import { TrialStatusEnum } from '@cast/types-organization-management';

import { TRIAL_CLUSTER_LIMIT } from './constants';

const shouldBlockClusterConnection = ({
  status,
  inGracePeriod,
}: {
  status?: TrialStatusEnum;
  inGracePeriod?: boolean;
}) =>
  !!inGracePeriod ||
  status === TrialStatusEnum.PENDING ||
  status === TrialStatusEnum.EXPIRED;

export const useIsTrialClusterConnectionBlocked = (): boolean => {
  const { data: trialStatus } = useTrialStatusQuery({ enabled: TRIAL_ENABLED });
  const { clusters } = useClusters();

  const isTrialStatusBlocked = shouldBlockClusterConnection({
    status: trialStatus?.status,
    inGracePeriod: trialStatus?.inGracePeriod,
  });

  return clusters.length >= TRIAL_CLUSTER_LIMIT && isTrialStatusBlocked;
};
